export const RECEIVE_INTRO = 'RECEIVE_INTRO'; //品牌头部信息
export const RECEIVE_COUPONS = 'RECEIVE_COUPONS';  // 品牌抵用券
export const RECEIVE_ENVIRONMENT = 'RECEIVE_ENVIRONMENT'; //品牌环境
export const RECEIVE_FEATURE = 'RECEIVE_FEATURE'; //特色服务
export const RECEIVE_FEATURE_CONTENT = 'RECEIVE_FEATURE_CONTENT'; //特色服务内容
export const RECEIVE_BRANCH = 'RECEIVE_BRANCH'; //分店
export const RECEIVE_BRANCH_ALL = 'RECEIVE_BRANCH_ALL'; //所有分店
export const RECEIVE_LECTURE = 'RECEIVE_LECTURE'; //课程
export const RECEIVE_LECTURE_CONTENT = 'RECEIVE_LECTURE_CONTENT'; //课程内容
export const RECEIVE_DETAIL = 'RECEIVE_DETAIL'; //介绍
export const SEND_FOLLOW = 'SEND_FOLLOW'; //点赞
export const ERROR_FOLLOW = 'ERROR_FOLLOW'; //点赞报错
export const CHECK_FOLLOW = 'CHECK_FOLLOW'; //检查点赞
export const SET_LOGIN = 'SET_LOGIN'; //检查点赞
export const ADD_FANS_COUNT = 'ADD_FANS_COUNT'; // 增加粉丝人数



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js